import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../auth/auth.service';
import { SupportService } from './support.service';
import { checkIfUserHasRoles } from '../../../../common/utils/utils';
import { AUTH_CONSTANTS } from '../../../auth/auth-constants';
import { ClientUtilities } from '../../../../publisher/src/publisher-ui/utils/client-utils';
import { NspUpgradeService } from './../../../../publisher/src/publisher-ui/upgrade/nsp-upgrade.service';
import { FeatureEnablementService } from './../../../../publisher/src/publisher-ui/upgrade/feature-enablement.service';


var clipboardJs = require("clipboard-js");
const _ = require('lodash');

@Component({
    selector: 'support',
    providers: [SupportService],
    template: require('./support.html')
})

// tslint:disable-next-line:component-class-suffix
export class SupportComponent implements OnInit {

    private getSupportHandler: Subscription;
    private loaded: boolean = false;
    private supportInfo: any;
    private admininstratorView: boolean = false;
    private selectedResourceId: string = '';
    private localHcspEndpoints: any = [];

    public isOvaBundleSubscribed: boolean;
    private isVsphereClient: boolean = false;
    private downloadOvaBundleHandler;
    private ovaBundleDownloadLink: string = '';
    private ovaLinkInfo: string = '';
    private showLinkSpinner: boolean = true;
    private enableInfoLink: boolean = false;
    private ovaBundleLink: boolean = false;
    private isLinkAvailable: boolean = false;
    private showHcxEDownloadLink: boolean = false;
    private featureMap: Map<string, object> = new Map<string, object>();
    isHCXWithoutCnC: boolean;

    constructor(public translate: TranslateService,
        public supportService: SupportService, public authService: AuthService,public nspUpgradeService:NspUpgradeService,public featureEnablementService : FeatureEnablementService) {
        translate.use(GlobalVariables.LOCALE);

        var hcxLicenseData = JSON.parse(sessionStorage.getItem('hcx-license-data'));
        this.isHCXWithoutCnC =  hcxLicenseData.data 
                                && hcxLicenseData.data.activationType 
                                && ['STANDALONE_CONNECTED', 'STANDALONE_DISCONNECTED'].indexOf(hcxLicenseData.data.activationType.toUpperCase()) > -1

        let roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];

        if (_.includes(roles, AUTH_CONSTANTS.OrgAdmin)) {
            if (this.authService.isVCDGVRDepricated || this.authService.VREALM_TYPE === AUTH_CONSTANTS.VIO) {
                this.admininstratorView = false;
            }
        } else {
            if (checkIfUserHasRoles(roles)) {
                this.admininstratorView = true;
            } else {
                this.admininstratorView = false;
            }
        }


        const me = this;

        this.supportService.getContext().then((contextResp) => {
            if (!!contextResp && contextResp.length > 0) {
                me.localHcspEndpoints = contextResp;
                me.selectedResourceId = contextResp[0].resourceId; // just picking the last one found for now.
                // console.log('support ui selected resource: ' + me.selectedResourceId);
                // console.log('support ui local endpoints: ' + JSON.stringify(me.localHcspEndpoints));

                this.getSupportHandler = this.supportService.supportData.subscribe((res) => {

                    if (res && res['data']) {
                        me.supportInfo = res['data'];
                    } else {
                        me.supportInfo = {};
                    }

                    me.loaded = true;
                });
            } else {
                console.error('support ui get context failed');
            }

            me.supportService.loadSupportInfo(me.selectedResourceId);
        });
        // this.getSupportHandler = this.supportService.supportData.subscribe((res) => {
        //     console.log('support ui constructor 2 ');
        //     if (res && res['data']) {
        //         me.supportInfo = res['data'];
        //     } else {
        //         me.supportInfo = {};
        //     }
        //     console.log('support ui constructor 3 ');
        //     me.supportService.getContext().then((contextResp) => {
        //         if (!!contextResp && contextResp.length > 0) {
        //             me.localHcspEndpoints = contextResp;
        //             me.selectedResourceId = contextResp[0].resourceId; // just picking the last one found for now.
        //             console.log('support ui selected resource: ' + me.selectedResourceId);
        //             console.log('support ui local endpoints: ' + JSON.stringify(me.localHcspEndpoints));
        //             me.loaded = true;
        //         } else {
        //             console.error('support ui get context failed');
        //         }
        //     });
        // }
        // );
    }

    public onVCChange(vcGuid) {
        this.selectedResourceId = vcGuid ? vcGuid : this.selectedResourceId;
        this.supportService.loadSupportInfo(vcGuid);
    }

    renderSystemType(data: any) {
        if (data) {
            if (data.systemType && data.systemType == "hcm") {
                return this.translate.instant('support.systemTypeHcm');
            } else if (data.systemType && data.systemType == "nsp") {
                return this.translate.instant('support.systemTypeNsp');
            } else {
                return data.systemType;
            }
        }
    }

    public ngOnInit() {
        this.nspUpgradeService.queryHcmInstances(
            () => setTimeout(() => this.initApplication(), 10), // success callback
            null); 
    }

    public initApplication() {
        console.log('support ui ngOnInit');
        const path = (window.location.pathname.match(/(.*)(\/publisher-ui)(\/.*|$)/) || [])[1];
        this.isVsphereClient = !!path && ClientUtilities.runningInPluginUI();
        this.getEnabledFeatures();
        !this.isHCXWithoutCnC && this.downloadOvaBundle(); //Call the Download API only if its not HCX without CnC
    }

    ngOnDestroy() {
        if (this.getSupportHandler) this.getSupportHandler.unsubscribe();
    }

    copyRowToClipboard() {
        if (!this.supportInfo) {
            return;
        }
        let info = this.supportInfo;
        let msg: string = '';
        msg += info.systemUuid ? 'System Uuid: ' + info.systemUuid + "\n" : '';
        msg += info.systemName ? 'System Name: ' + info.systemName + "\n" : '';

        if (info.systemType) {
            msg += 'System Type: ';
            if (info.systemType === 'nsp') {
                msg += this.translate.instant('support.systemTypeNsp');
            } else if (info.systemType === 'hcm') {
                msg += this.translate.instant('support.systemTypeHcm');
            }
            msg += "\n";
        }

        msg += info.version ? 'Version: ' + info.version + "\n" : '';
        msg += info.linkLastCommunicated ? 'Link Last Communicated: ' + info.linkLastCommunicated + "\n" : '';
        msg += info.linkVerified ? 'Link Verified: ' + info.linkVerified + "\n" : '';
        msg += info.linkEstablished ? 'Link Established: ' + info.linkEstablished + "\n" : '';
        clipboardJs.copy(msg);
    }

    // Ova Support
    // The feature enablement API will use the feature "SUPPORT_SYSTEMUPDATES" in order to provide the HCX-E download link to the Org Admin role
    // in VCD. This was introduced as part of 2422919 and is modified as part of 2865972.

    private getEnabledFeatures(): any {
        this.featureEnablementService.getFeatureEnablement(
            this.nspUpgradeService.getLocalHcmReference()['hcsp']['uuid'],
            {
                feature: 'SUPPORT_SYSTEMUPDATES'
            }
        ).subscribe((result:any) => {
            if (result.errors && result.errors.length > 0) {
                let errorMessage: string = '';
                for (const error of result.errors) {
                    errorMessage = errorMessage.concat(errorMessage, error.text);
                    console.log(errorMessage);
                }
                console.error(JSON.stringify(errorMessage));
            } else {
                this.featureMap.set('SUPPORT_SYSTEMUPDATES', result);
                this.showHcxEDownloadLink = this.isFeatureEnabled('SUPPORT_SYSTEMUPDATES', 'ShowHcxEDownloadLink');
            }
        }, (error) => {
            console.error("'Error calling feature enablement API:", error);
        }
        );
    }

    private isFeatureEnabled(feature: string, operation: string): boolean {
        if (!!this.featureMap) {
            const featureEnablement = this.featureMap.get(feature);
            if (!!featureEnablement) {
                if (!!featureEnablement['operations'] && !!featureEnablement['operations'].includes(operation)) {
                    return true;
                }
            }
        }
        return false;
    }

    downloadOvaBundle() {
        let me = this;
        let downloadJobId;
        me.isOvaBundleSubscribed = true;
        if (me.isVsphereClient == false) {
            me.supportService.downloadOvaBundleFile().subscribe(
                response => {
                    if (response.success) {
                        downloadJobId = response.data.downloadId;
                    }
                    me.downloadOvaBundleHandler = me.supportService.pollOvaBundleDownloadStatus(downloadJobId).subscribe(data => {
                        me.handleDownloadOvaResponse(data);
                    }, error => {
                        //console.log('error', error);
                    });
                    //console.log('response', response)
                },
                error => {
                    //console.log('response error', error)
                },
                () => { }
            )
        }
    }

    handleDownloadOvaResponse(data: any) {
        let me = this;
        if (data == null) {
            me.ovaBundleDownloadLink = '';
            //me.downloadOvaBundleHandler.unsubscribe();
            return;
        }

        let response = data;
        if (response.status == '204') {
            me.ovaBundleDownloadLink = '';
            me.downloadOvaBundleHandler.unsubscribe();
            me.isOvaBundleSubscribed = false;
            return;
        }

        if (response.data) {
            switch (response.data.status) {
                case 'COMPLETE':
                    if ((response.data.downloadOvaLinkInformation.downloadUrl == 'undefined') ||
                        (response.data.downloadOvaLinkInformation.hasOwnProperty('downloadUrl') == false)
                    ) {
                        me.ovaBundleDownloadLink = '';
                        me.ovaLinkInfo = response.data.downloadOvaLinkInformation;
                        me.isOvaBundleSubscribed = false;
                        me.showLinkSpinner = false;
                        me.enableInfoLink = true;
                        me.downloadOvaBundleHandler.unsubscribe();
                    }
                    else if (response.data.downloadOvaLinkInformation.downloadUrl != '') {
                        me.ovaBundleDownloadLink = response.data.downloadOvaLinkInformation.downloadUrl;
                        me.isOvaBundleSubscribed = false;
                        me.downloadOvaBundleHandler.unsubscribe();
                    }
                    break;
            }

        }
    }

    // Display Ova links
    checkOvaBundle() {
        let me = this;
        me.ovaLinkInfo = "";
        //me.downloadOvaBundle()
        me.ovaBundleLink = true;    //Check to enable "Request Down Link" button 
        me.isLinkAvailable = true;  //Check to enable "Request Down Link" button with spinner

        let timerId;
        if (me.ovaBundleDownloadLink.length == 0) {
            //timer to show spinner after user clicks on "Request Down load link"
            if (!me.isOvaBundleSubscribed) {
                me.downloadOvaBundle();
                me.showLinkSpinner = true;
                me.enableInfoLink = false;
                timerId = setTimeout(function () {
                    me.showLinkSpinner = false;
                    me.enableInfoLink = true;  //shows info icon when there is no link available
                }, 180000);
            }
        }
        else {
            clearTimeout(timerId);
        }

    }

    //Copy url to clipboard
    copyOvaBundleLink(event) {
        let me = this;
        let urlToCopy = me.ovaBundleDownloadLink;
        clipboardJs.copy(urlToCopy);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/support/support.component.ts